import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { publicCardSx, publicColors, publicContainerSx, publicH2Sx, publicSectionSx, publicSubtitleSx } from './publicTheme';

const testimonials = [
    {
        text: 'Na correria da feira, registrar venda com foto no tablet resolveu o caos de anotação. Consigo bater o que vendi com o que produzi depois.',
        author: 'Fabiane D. Schran',
        role: 'Vendas presenciais',
    },
    {
        text: 'Após conectar todas minhas impressoras, consegui ter uma visão que nem imaginava sobre a produtividade de cada uma das máquinas e hoje tenho segurança total para a tomada de decisão na expansão da minha farm.',
        author: 'Andre Cardoso',
        role: 'Produção sob demanda',
    },
];

const Testimonials = () => (
    <Box id="depoimentos" component="section" sx={{ ...publicSectionSx, bgcolor: publicColors.surface }}>
        <Box sx={publicContainerSx}>
            <Typography component="h2" sx={{ ...publicH2Sx, textAlign: 'center' }}>
                Quem já decide com mais clareza
            </Typography>
            <Typography sx={{ ...publicSubtitleSx, textAlign: 'center', mb: 5 }}>
                Makers que trocaram achismo por registro, custo visível e rotina de vendas.
            </Typography>
            <Grid container spacing={3}>
                {testimonials.map(({ text, author, role }) => (
                    <Grid item xs={12} md={6} key={author}>
                        <Box sx={{ ...publicCardSx, position: 'relative' }}>
                            <FormatQuoteIcon
                                sx={{ position: 'absolute', top: 16, right: 16, color: publicColors.border, fontSize: 40 }}
                            />
                            <Typography sx={{ color: publicColors.inkMuted, lineHeight: 1.75, mb: 2, fontStyle: 'italic' }}>
                                “{text}”
                            </Typography>
                            <Typography sx={{ fontWeight: 700, color: publicColors.ink }}>{author}</Typography>
                            <Typography variant="body2" sx={{ color: publicColors.inkSoft }}>{role}</Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    </Box>
);

export default Testimonials;
